import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-3-2', 'Crop32', [["path",{"d":"M4 9a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -6"}]]);